import { CURRENT_COMMUNICATION_PLAN_LOAD_SUCCESS } from 'actions/currentCommunicationPlan';

const defaultState = {
  planId: undefined,
  workflowHeaderPlanId: undefined,
};

export default function currentCommunicationPlan(state = defaultState, action) {
  const { type, payload } = action;
  switch (type) {
    case 'SET_HEADER_WORKLFOW_ID':
      return {
        ...state,
        planId: payload,
        workflowHeaderPlanId: payload,
      };
    case CURRENT_COMMUNICATION_PLAN_LOAD_SUCCESS:
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
}
